"use client";

import { CurrencyProvider } from "@/app/_providers/currency";

export function PricingWithCurrency({ children }: { children: React.ReactNode }) {
  return <CurrencyProvider>{children}</CurrencyProvider>;
}
